module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_type_chapel@3x-1fa3c7e5baa4e38696c92d90b563b36f.webp";